module.exports = __webpack_public_path__ + "static/media/upload_media.2d747981.svg";